<div>
  <div>
    <div class="justify-content-between" style="display: flex">
      <!-- <h4 class="card-title" style="font-weight: 600">
        {{ item.typeOfContent }} - {{ item.containerType }}
        <small class="description">#{{ item.batch }}</small> -->

      <!-- <button
          class="btn btnstatus ml-3"
          [ngClass]="[
            item.status == 'Pending' ? 'btn-danger' : '',
            item.status == 'In Progress' ? 'btn-warning' : '',
            item.status == 'Completed' ? 'btn-success' : ''
          ]"
          mat-button
          [matMenuTriggerFor]="menu"
        >
          {{ item.status }}
        </button> -->
      <!-- <mat-menu #menu="matMenu">
          <button
            [disabled]="item.status == 'Pending'"
            (click)="changestatusmanifest(item, 'Pending')"
            class="btn btn-outline-danger"
            mat-menu-item
          >
            Pending
          </button>
          <button
            [disabled]="item.status == 'In Progress'"
            (click)="changestatusmanifest(item, 'In Progress')"
            class="btn btn-outline-warning"
            mat-menu-item
          >
            In Progress
          </button>
          <button
            [disabled]="item.status == 'Completed'"
            (click)="showMarkCompleted()"
            class="btn btn-outline-success"
            mat-menu-item
          >
            Completed
          </button>
        </mat-menu> -->
      <!-- </h4> -->
      <div class="d-flex">
        <div class="d-flex mr-2">
          <span class="mr-2">
            <b>{{ item.typeOfContent }} - {{ item.containerType }}</b>
          </span>
          <small class="description">#{{ item.batch }}</small>
        </div>
        <!-- <app-button-select
          [options]="optionsButtonSelect"
          [(selected)]="item.status"
          (selectedChange)="showMarkCompleted(item, item.status)"
          [label]="'Status'"
        >
        </app-button-select> -->
      </div>
      <div class="d-flex">
        <!-- <a
          *ngIf="includesPI"
          class="gts-btn-primary-outline mr-2"
          target="_blank"
          [routerLink]="['/batch-container-inventory', item.id]"
        >
          <span class="gts-btn-icon-left">open_in_new</span>
          <span class="gts-btn-text">Open Batch</span>
        </a> -->
        <button
          class="gts-btn-primary-outline mr-2"
          (click)="printItemManifest(item)"
        >
          <span class="gts-btn-icon-left">print</span>
          <span class="gts-btn-text">Print</span>
        </button>

        <button
          *ngIf="item.status == 'Pending'"
          class="gts-btn-primary-outline mr-2"
          (click)="confirmDeleteBatch(item)"
        >
          <span class="gts-btn-icon-left">delete</span>
          <span class="gts-btn-text">Delete</span>
        </button>
        <!-- <button
          *ngIf="item.status == 'Pending'"
          class="gts-btn-primary"
          (click)="changestatusmanifest(item, 'In Progress')"
          data-toggle="tab"
          role="tablist"
        >
          <span class="gts-btn-text"> Mark In Progress</span>
        </button>
        <button
          *ngIf="item.status == 'In Progress'"
          (click)="showMarkCompleted(item, 'Completed')"
          class="gts-btn-primary"
          data-toggle="tab"
          role="tablist"
        >
          <span class="gts-btn-text"> Mark Completed</span>
        </button> -->
        <app-button-select
          [outline]="true"
          [icon]="'circle'"
          [label]="'Status'"
          [optionsIcons]="optionsButtonSelect"
          [(selected)]="item.status"
          (selectedChange)="showMarkCompleted(item, item.status)"
        >
        </app-button-select>
      </div>
    </div>

    <div class="mt-4">
      <div class="d-flex" style="justify-content: space-between">
        <!-- <ng-template #isContainer
          >Batch ID# {{ item.id }} <br />{{
            item.batchPriorityLevel
          }}</ng-template
        > -->
        <div>
          <!-- <div style="position: relative; width: fit-content">
            <span *ngIf="total_chats > 0" class="badge top-right">{{
              total_chats
            }}</span>
            <i
              style="
                cursor: pointer;
                color: rgba(26, 187, 199, 0.795);
                margin-right: 10px;
              "
              class="material-icons btn-link btn-just-icon"
              (click)="showCommentsBatch(item.id)"
            >
              chat
            </i>
          </div> -->

          <!-- <i
            style="
              cursor: pointer;
              color: rgba(26, 187, 199, 0.795);
              margin-right: 10px;
            "
            class="material-icons btn-link btn-just-icon"
            (click)="splitItemNew(item)"
            *ngIf="
              (item.laptopsDone !== 1 ||
                item.hardDrivesDone !== 1 ||
                item.desktopsDone !== 1 ||
                item.allinoneDone !== 1 ||
                (item.containersDevices > 0 &&
                  item.containersDevicesDone != 1) ||
                item.ssdDone !== 1) &&
              !item.dosplit
            "
            >call_split</i
          > -->
        </div>
      </div>
    </div>
    <mat-tab-group
      (selectedTabChange)="onTabChange($event)"
      class="mat-typography"
    >
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style="margin-right: 8px">info</mat-icon>
          Batch Info
        </ng-template>
        <ng-template matTabContent>
          <mat-form-field
            *ngIf="item?.processingInstruction"
            style="padding-top: 24px"
            class="example-full-width has-label mr-2"
          >
            <mat-label>Priority Level</mat-label>
            <mat-select
              [(ngModel)]="item.processingInstruction.poPriorityLevel"
              name="po_priority_level"
              id="po_priority_level"
              disabled
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <mat-option value="null" disabled>Select Priority</mat-option>
              <mat-option value="LOWPRIORITY">Low Priority</mat-option>
              <mat-option value="MEDIUMPRIORITY">Medium Priority</mat-option>
              <mat-option value="FASTPRIORITY">Fast Priority</mat-option>
              <mat-option value="URGENTPRIORITY">Urgent Same Day</mat-option>
            </mat-select>
            <!-- <input
              type="text"
              name="Priority Level"
              [(ngModel)]="item.processingInstruction.poPriorityLevel"
              matInput
              disabled
            /> -->
          </mat-form-field>
          <div style="padding-top: 0px" class="">
            <div>
              <div
                *ngIf="item.containerType == 'HDD/SSD'"
                class="tab-pane active"
                id="link1"
              >
                <mat-form-field class="example-full-width has-label">
                  <mat-label for="caddiesForm"
                    >Do the drives have caddies?</mat-label
                  >
                  <mat-select
                    disabled
                    name="caddiesForm"
                    id="caddiesForm"
                    [(ngModel)]="item.caddies"
                    (change)="changecaddies($e)"
                  >
                    <mat-option value="">Please select an option</mat-option>
                    <mat-option value="YesALL">Yes - All</mat-option>
                    <mat-option value="YesSome">Yes - Some</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="d-flex">
                  <mat-form-field class="example-full-width has-label mr-2">
                    <mat-label> Quantity of HDD?</mat-label>
                    <input
                      type="number"
                      min="0"
                      (keypress)="mtds.onlyNumber($event)"
                      name="hdd_qty"
                      [(ngModel)]="item.hardDrives"
                      matInput
                      disabled
                    />
                  </mat-form-field>
                  <button
                    [disabled]="item.processingHDD"
                    (click)="showMarkDone(item, 'HARDDRIVES')"
                    *ngIf="
                      item.hardDrives > 0 &&
                      (item.hardDrivesDone == 0 || item.hardDrivesDone == null)
                    "
                    class="gts-btn-primary-outline"
                  >
                    <span *ngIf="!item.processingHDD" class="gts-btn-icon-left"
                      >check_circle_outline</span
                    >
                    <span *ngIf="item.processingHDD" class="gts-btn-icon-left"
                      >sync</span
                    >
                    <span class="gts-btn-text">{{
                      item.processingHDD ? "" : "Mark as done"
                    }}</span>
                  </button>
                </div>
                <div class="d-flex">
                  <mat-form-field class="example-full-width has-label mr-2">
                    <mat-label> Quantity of SSD?</mat-label>
                    <input
                      type="number"
                      min="0"
                      (keypress)="mtds.onlyNumber($event)"
                      name="ssd_qty"
                      [(ngModel)]="item.ssd"
                      matInput
                      disabled
                    />
                  </mat-form-field>
                  <button
                    [disabled]="item.processingSSD"
                    (click)="showMarkDone(item, 'SSD')"
                    *ngIf="
                      item.ssd > 0 &&
                      (item.ssdDone == 0 || item.ssdDone == null)
                    "
                    class="gts-btn-primary-outline"
                  >
                    <span *ngIf="!item.processingSSD" class="gts-btn-icon-left"
                      >check_circle_outline</span
                    >
                    <span *ngIf="item.processingSSD" class="gts-btn-icon-left"
                      >sync</span
                    >
                    <span class="gts-btn-text">
                      {{ item.processingSSD ? "" : "Mark as done" }}
                    </span>
                  </button>

                  <button
                    *ngIf="item.ssdDone == 1 && item.ssd > 0"
                    class="gts-btn-primary-outline"
                    disabled
                  >
                    <span class="gts-btn-icon-left">
                      check_circle_outline
                    </span>
                    <span class="gts-btn-text"> Done</span>
                  </button>
                </div>

                <!-- <div class="d-flex">
              <h5 style="font-weight: 500">Do the drives have caddies?</h5>
              <p class="ml-3" *ngIf="item.caddies == 'YesALL'">Yes - All</p>
              <p class="ml-3" *ngIf="item.caddies == 'YesSome'">Yes - Some</p>
              <p class="ml-3" *ngIf="item.caddies == 'No'">No</p>
            </div> -->
                <!-- <div class="d-flex">
              <h5 style="font-weight: 500">Quantity of HDD:</h5>
              <p class="ml-3">{{ item.hardDrives ? item.hardDrives : 0 }}</p>
              <button
                [disabled]="item.processingHDD"
                (click)="showMarkDone(item, 'HARDDRIVES')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.hardDrives > 0 &&
                  (item.hardDrivesDone == 0 || item.hardDrivesDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingHDD" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingHDD" class="material-icons"
                  >sync</span
                >
                {{ item.processingHDD ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.hardDrivesDone == 1 && item.hardDrives > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button>
            </div>
            <div class="d-flex">
              <h5 style="font-weight: 500">Quantity of SSD:</h5>
              <p class="ml-3">{{ item.ssd ? item.ssd : 0 }}</p>
              <button
                [disabled]="item.processingSSD"
                (click)="showMarkDone(item, 'SSD')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.ssd > 0 && (item.ssdDone == 0 || item.ssdDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingSSD" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingSSD" class="material-icons"
                  >sync</span
                >
                {{ item.processingSSD ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.ssdDone == 1 && item.ssd > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button>
            </div> -->
                <div *ngIf="item.allInOne > 0" class="d-flex">
                  <mat-form-field class="example-full-width has-label">
                    <mat-label>Quantity of AIO</mat-label>
                    <input
                      type="number"
                      min="0"
                      name="ssd_qty"
                      [(ngModel)]="item.allInOne"
                      matInput
                      disabled
                    />
                  </mat-form-field>
                  <button
                    [disabled]="item.processingAIO"
                    (click)="showMarkDone(item, 'AIO')"
                    *ngIf="
                      item.allInOne > 0 &&
                      (item.allinoneDone == 0 || item.allinoneDone == null)
                    "
                    class="gts-btn-primary-outline"
                  >
                    <span *ngIf="!item.processingAIO" class="gts-btn-icon-left"
                      >check_circle_outline</span
                    >
                    <span *ngIf="item.processingAIO" class="gts-btn-icon-left"
                      >sync</span
                    >
                    <span class="gts-btn-text">
                      {{ item.processingAIO ? "" : "Mark as done" }}</span
                    >
                  </button>

                  <button
                    *ngIf="item.allinoneDone == 1 && item.allInOne > 0"
                    class="gts-btn-primary-outline"
                    disabled
                  >
                    <span class="gts-btn-icon-left">
                      check_circle_outline
                    </span>
                    <span class="gts-btn-text"> Done</span>
                  </button>
                </div>
                <!-- 
            <div *ngIf="item.allInOne > 0" class="d-flex">
              <h5 style="font-weight: 500">Quantity of AIO:</h5>
              <p class="ml-3">{{ item.allInOne ? item.allInOne : 0 }}</p>

              <button
                [disabled]="item.processingAIO"
                (click)="showMarkDone(item, 'AIO')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.allInOne > 0 &&
                  (item.allinoneDone == 0 || item.allinoneDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingAIO" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingAIO" class="material-icons"
                  >sync</span
                >
                {{ item.processingAIO ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.allinoneDone == 1 && item.allInOne > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button>
            </div> -->
                <div *ngIf="item.desktops > 0" class="d-flex">
                  <h5 style="font-weight: 500">Quantity of Desktops:</h5>
                  <p class="ml-3">{{ item.desktops ? item.desktops : 0 }}</p>

                  <button
                    [disabled]="item.processingDESKTOP"
                    (click)="showMarkDone(item, 'DESKTOP')"
                    style="margin-left: 15px; margin-top: 0px"
                    *ngIf="
                      item.desktops > 0 &&
                      (item.desktopsDone == 0 || item.desktopsDone == null)
                    "
                    class="btn btn-info btn-sm"
                  >
                    <span *ngIf="!item.processingDESKTOP" class="material-icons"
                      >check_circle_outline</span
                    >
                    <span *ngIf="item.processingDESKTOP" class="material-icons"
                      >sync</span
                    >
                    {{ item.processingDESKTOP ? "" : "Mark as done" }}
                  </button>

                  <button
                    style="margin-left: 15px; margin-top: 0px"
                    *ngIf="item.desktopsDone == 1 && item.desktops > 0"
                    class="btn btn-success btn-sm"
                  >
                    <span class="material-icons"> check_circle_outline </span
                    >Done
                  </button>
                </div>
                <div *ngIf="item.laptops > 0" class="d-flex">
                  <h5 style="font-weight: 500">Quantity of Laptops:</h5>
                  <p class="ml-3">{{ item.laptops ? item.laptops : 0 }}</p>

                  <button
                    [disabled]="item.processingLAPTOP"
                    (click)="showMarkDone(item, 'LAPTOP')"
                    style="margin-left: 15px; margin-top: 0px"
                    *ngIf="
                      item.laptops > 0 &&
                      (item.laptopsDone == 0 || item.laptopsDone == null)
                    "
                    class="btn btn-info btn-sm"
                  >
                    <span *ngIf="!item.processingLAPTOP" class="material-icons"
                      >check_circle_outline</span
                    >
                    <span *ngIf="item.processingLAPTOP" class="material-icons"
                      >sync</span
                    >
                    {{ item.processingLAPTOP ? "" : "Mark as done" }}
                  </button>

                  <button
                    style="margin-left: 15px; margin-top: 0px"
                    *ngIf="item.laptopsDone == 1 && item.laptops > 0"
                    class="btn btn-success btn-sm"
                  >
                    <span class="material-icons"> check_circle_outline </span
                    >Done
                  </button>
                </div>
              </div>
              <div
                *ngIf="item.containerType == 'Devices'"
                class="tab-pane active"
                id="link1"
              >
                <div class="d-flex">
                  <mat-form-field class="example-full-width has-label mr-2">
                    <mat-label>Quantity of AIO</mat-label>
                    <input
                      type="number"
                      min="0"
                      name="ssd_qty"
                      [(ngModel)]="item.allInOne"
                      matInput
                      disabled
                    />
                  </mat-form-field>
                  <button
                    [disabled]="item.processingAIO"
                    (click)="showMarkDone(item, 'AIO')"
                    *ngIf="
                      item.allInOne > 0 &&
                      (item.allinoneDone == 0 || item.allinoneDone == null)
                    "
                    class="gts-btn-primary-outline"
                  >
                    <span *ngIf="!item.processingAIO" class="gts-btn-icon-left"
                      >check_circle_outline</span
                    >
                    <span *ngIf="item.processingAIO" class="gts-btn-icon-left"
                      >sync</span
                    >
                    <span class="gts-btn-text">
                      {{ item.processingAIO ? "" : "Mark as done" }}</span
                    >
                  </button>

                  <button
                    *ngIf="item.allinoneDone == 1 && item.allInOne > 0"
                    class="gts-btn-primary-outline"
                    disabled
                  >
                    <span class="gts-btn-icon-left">
                      check_circle_outline
                    </span>
                    <span class="gts-btn-text"> Done</span>
                  </button>
                </div>

                <!-- <div class="d-flex">
              <h5 style="font-weight: 500">Quantity of AIO:</h5>
              <p class="ml-3">{{ item.allInOne ? item.allInOne : 0 }}</p>
              <button
                [disabled]="item.processingAIO"
                (click)="showMarkDone(item, 'AIO')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.allInOne > 0 &&
                  (item.allinoneDone == 0 || item.allinoneDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingAIO" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingAIO" class="material-icons"
                  >sync</span
                >
                {{ item.processingAIO ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.allinoneDone == 1 && item.allInOne > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button>
            </div> -->
                <div class="d-flex">
                  <mat-form-field class="example-full-width has-label mr-2">
                    <mat-label>Quantity of Desktops</mat-label>
                    <input
                      type="number"
                      min="0"
                      name="ssd_qty"
                      [(ngModel)]="item.desktops"
                      matInput
                      disabled
                    />
                  </mat-form-field>
                  <button
                    [disabled]="item.processingDESKTOP"
                    (click)="showMarkDone(item, 'DESKTOP')"
                    *ngIf="
                      item.desktops > 0 &&
                      (item.desktopsDone == 0 || item.desktopsDone == null)
                    "
                    class="gts-btn-primary-outline"
                  >
                    <span
                      *ngIf="!item.processingDESKTOP"
                      class="gts-btn-icon-left"
                      >check_circle_outline</span
                    >
                    <span
                      *ngIf="item.processingDESKTOP"
                      class="gts-btn-icon-left"
                      >sync</span
                    >
                    <span class="gts-btn-text">
                      {{ item.processingDESKTOP ? "" : "Mark as done" }}</span
                    >
                  </button>

                  <button
                    *ngIf="item.desktopsDone == 1 && item.desktops > 0"
                    class="gts-btn-primary-outline"
                    disabled
                  >
                    <span class="gts-btn-icon-left">
                      check_circle_outline
                    </span>
                    <span class="gts-btn-text"> Done</span>
                  </button>
                  <!-- <h5 style="font-weight: 500">Quantity of Desktops:</h5>
              <p class="ml-3">{{ item.desktops ? item.desktops : 0 }}</p>
              <button
                [disabled]="item.processingDESKTOP"
                (click)="showMarkDone(item, 'DESKTOP')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.desktops > 0 &&
                  (item.desktopsDone == 0 || item.desktopsDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingDESKTOP" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingDESKTOP" class="material-icons"
                  >sync</span
                >
                {{ item.processingDESKTOP ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.desktopsDone == 1 && item.desktops > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button> -->
                </div>
                <div class="d-flex">
                  <mat-form-field class="example-full-width has-label mr-2">
                    <mat-label>Quantity of Laptops</mat-label>
                    <input
                      type="number"
                      min="0"
                      name="ssd_qty"
                      [(ngModel)]="item.laptops"
                      matInput
                      disabled
                    />
                  </mat-form-field>
                  <button
                    [disabled]="item.processingLAPTOP"
                    (click)="showMarkDone(item, 'LAPTOP')"
                    *ngIf="
                      item.laptops > 0 &&
                      (item.laptopsDone == 0 || item.laptopsDone == null)
                    "
                    class="gts-btn-primary-outline"
                  >
                    <span
                      *ngIf="!item.processingLAPTOP"
                      class="gts-btn-icon-left"
                      >check_circle_outline</span
                    >
                    <span
                      *ngIf="item.processingLAPTOP"
                      class="gts-btn-icon-left"
                      >sync</span
                    >
                    <span class="gts-btn-text">
                      {{ item.processingLAPTOP ? "" : "Mark as done" }}</span
                    >
                  </button>

                  <button
                    *ngIf="item.laptopsDone == 1 && item.laptops > 0"
                    class="gts-btn-primary-outline"
                    disabled
                  >
                    <span class="gts-btn-icon-left">
                      check_circle_outline
                    </span>
                    <span class="gts-btn-text"> Done</span>
                  </button>

                  <!-- <h5 style="font-weight: 500">Quantity of Laptops:</h5>
              <p class="ml-3">{{ item.laptops ? item.laptops : 0 }}</p>
              <button
                [disabled]="item.processingLAPTOP"
                (click)="showMarkDone(item, 'LAPTOP')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.laptops > 0 &&
                  (item.laptopsDone == 0 || item.laptopsDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingLAPTOP" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingLAPTOP" class="material-icons"
                  >sync</span
                >
                {{ item.processingLAPTOP ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.laptopsDone == 1 && item.laptops > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button> -->
                </div>

                <div *ngIf="item.hardDrives > 0" class="d-flex">
                  <h5 style="font-weight: 500">Quantity of HDD:</h5>
                  <p class="ml-3">
                    {{ item.hardDrives ? item.hardDrives : 0 }}
                  </p>
                </div>
              </div>
              <div
                *ngIf="item.containerType == 'Mobile Devices'"
                class="tab-pane active"
                id="link3"
              >
                <div class="d-flex">
                  <mat-form-field class="example-full-width has-label mr-2">
                    <mat-label> Quantity of Mobile Devices?</mat-label>
                    <input
                      disabled
                      type="number"
                      min="0"
                      name="mobiledevices_qty"
                      [(ngModel)]="item.mobileDevices"
                      matInput
                      required
                    />
                  </mat-form-field>
                  <button
                    [disabled]="item.processingMOBILEDEVICES"
                    (click)="showMarkDone(item, 'MOBILEDEVICES')"
                    *ngIf="
                      item.mobileDevices > 0 &&
                      (item.mobileDevicesDone == 0 ||
                        item.mobileDevicesDone == null)
                    "
                    class="gts-btn-primary-outline"
                  >
                    <span
                      *ngIf="item.processingMOBILEDEVICES"
                      class="gts-btn-icon-left"
                      >sync</span
                    >
                    <span
                      class="gts-btn-icon-left"
                      *ngIf="!item.processingMOBILEDEVICES"
                    >
                      check_circle_outline
                    </span>
                    <span class="gts-btn-text">
                      {{
                        item.processingMOBILEDEVICES ? "" : "Mark as done"
                      }}</span
                    >
                  </button>

                  <button
                    *ngIf="
                      item.mobileDevicesDone == 1 && item.mobileDevices > 0
                    "
                    class="gts-btn-primary-outline"
                  >
                    <span class="material-icons"> check_circle_outline </span
                    >Done
                  </button>
                </div>
              </div>
              <!-- <div style="width: 145px; display: flex">
              <h5 style="font-weight: 500; align-self: center">Weight:::</h5>
            </div> -->
              <div class="d-flex w-100">
                <mat-form-field class="example-full-width">
                  <mat-label>Weight (lbs)</mat-label>
                  <input
                    [disabled]="weightInputActivated == false"
                    id="inputWeight{{ item.id }}"
                    matInput
                    (keydown.enter)="lockWeight(item)"
                    [(ngModel)]="item.weight"
                    type="text"
                  />
                </mat-form-field>
                <div class="ml-2">
                  <button
                    *ngIf="!weightInputActivated"
                    (click)="unlockWeight(item)"
                    class="gts-btn-primary-outline"
                  >
                    <span class="gts-btn-icon"> edit </span>
                    <!-- <span class="gts-btn-text"> Done</span> -->
                  </button>
                  <div class="d-flex">
                    <button
                      *ngIf="weightInputActivated"
                      (click)="lockWeight(item)"
                      class="gts-btn-primary mr-2"
                    >
                      <span class="gts-btn-text"> Done</span>
                    </button>
                    <button
                      *ngIf="weightInputActivated"
                      (click)="resetItem('weight')"
                      class="gts-btn-primary-outline"
                    >
                      <span class="gts-btn-text">Cancel</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                style="justify-content: end"
                *ngIf="
                  item.internalLocation && item.internalLocation.locationName
                "
              >
                <div
                  *ngIf="locationChanged"
                  class="alert alert-success w-100"
                  style="width: 100%; display: flex"
                  role="alert"
                >
                  <span>Location has changed to Wipe Room: 0-0-0-0</span>
                </div>
                <div class="locationinput-{{ item.id }} d-flex">
                  <mat-form-field class="example-full-width">
                    <mat-label> Current Location: </mat-label>
                    <input
                      disabled
                      matInput
                      (change)="handleChange($event)"
                      [(ngModel)]="val"
                      type="text"
                    />
                  </mat-form-field>
                  <div class="ml-2">
                    <button
                      *ngIf="editLoc == false"
                      (click)="unlocklocation(item)"
                      class="gts-btn-primary-outline"
                    >
                      <span class="gts-btn-icon"> edit </span>
                    </button>
                    <button
                      *ngIf="editLoc == true"
                      (click)="locklocation(item.id)"
                      class="gts-btn-primary-outline locationselect-{{
                        item.id
                      }}"
                    >
                      <span class="gts-btn-text">Cancel</span>
                    </button>
                  </div>
                </div>
                <div
                  style="display: none"
                  class="locationselect-{{ item.id }} "
                >
                  <div class="d-flex align-items-center">
                    <div class="w-100">
                      <mat-progress-bar
                        style="width: 100%"
                        *ngIf="loadingLocationsNewContainer"
                        id="loadingbar"
                        mode="indeterminate"
                      >
                      </mat-progress-bar>

                      <app-filter-object
                        class="w-100"
                        *ngIf="!loadingLocationsNewContainer"
                        [options]="locationsListNewContainer"
                        placeholder="Select new Location"
                        [value]="newcontainerInternallocation_id"
                        (selectChange)="
                          changeLocationEditContainer($event, item)
                        "
                        [disabled]="locationsListNewContainer.length == 0"
                      >
                      </app-filter-object>
                    </div>

                    <mat-checkbox
                      style="width: 30%"
                      class="example-margin"
                      (change)="onCheckboxChange($event)"
                      >Show External Locations</mat-checkbox
                    >
                  </div>
                </div>
              </div>

              <label *ngIf="loadingUsers"
                >Loading Users <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
              ></label>

              <div class="d-flex">
                <app-filter-object
                  class="w-100"
                  *ngIf="!loadingUsers"
                  [options]="usersList"
                  [disabled]="assignInputActivated"
                  placeholder="Assign User"
                  [value]="item.assignTo"
                  (selectChange)="item.assignTo = $event.id"
                >
                </app-filter-object>
                <div class="ml-2">
                  <button
                    *ngIf="assignInputActivated"
                    (click)="unlockAssign(item)"
                    class="gts-btn-primary-outline"
                  >
                    <span class="gts-btn-icon"> edit </span>
                  </button>
                  <div class="d-flex">
                    <button
                      *ngIf="!assignInputActivated"
                      (click)="lockAssign(item)"
                      class="gts-btn-primary mr-2"
                    >
                      <span class="gts-btn-text"> Done</span>
                    </button>
                    <button
                      *ngIf="!assignInputActivated"
                      (click)="resetItem('user')"
                      class="gts-btn-primary-outline"
                    >
                      <span class="gts-btn-text">Cancel</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style="margin-right: 8px">add</mat-icon>
          Add Item
        </ng-template>
        <ng-template matTabContent>
          <div style="padding-top: 20px">
            <form #f2="ngForm">
              <mat-form-field class="example-full-width has-label">
                <mat-label for="typeInventory">Add by</mat-label>
                <mat-select
                  name="typeInventory"
                  [(ngModel)]="nuevo.type"
                  (change)="cleanValues()"
                  required
                >
                  <mat-option value="" disabled
                    >Please select an option</mat-option
                  >
                  <mat-option value="serialnumber">Serial Number</mat-option>
                  <mat-option value="dashboardid">Dashboard ID</mat-option>
                  <mat-option value="iqid">IQ ID</mat-option>
                  <mat-option value="poline">Po Number & Line Item</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Value</mat-label>
                <textarea
                  name="nuevoValue"
                  [(ngModel)]="nuevo.value"
                  rows="3"
                  required
                  (keydown)="onEnter($event)"
                  matInput
                ></textarea>
              </mat-form-field>
              <!-- <div class="form-group">
                <label for="typeInventory">Add by</label>
                <select
                  name="typeInventory"
                  [(ngModel)]="nuevo.type"
                  (change)="cleanValues()"
                  class="form-control"
                  required
                >
                  <option value="" disabled>Please select an option</option>
                  <option value="serialnumber">Serial Number</option>
                  <option value="dashboardid">Dashboard ID</option>
                  <option value="iqid">IQ ID</option>
                  <option value="poline">Po Number & Line Item</option>
                </select>
              </div> -->
              <div *ngIf="itemsID.length > 0 || itemsAdd.length > 0">
                <div *ngFor="let item of itemsID">
                  <div
                    *ngIf="item.status == 0"
                    class="alert alert-danger w-100"
                    role="alert"
                  >
                    {{ nuevo.value }} not found
                  </div>
                  <div
                    class="alert alert-warning w-100"
                    *ngIf="item.status == 1"
                  >
                    <div
                      class="d-flex align-items-center"
                      [ngClass]="{ red: item.status === 0 }"
                    >
                      Item {{ item.id_inventory }}
                      {{ "is inside batch " + item.id_batch }}.
                      {{
                        item.name_container +
                          " Are you sure you want to move this item?"
                      }}
                      <button
                        (click)="removeItemFromArray(item.id_inventory)"
                        class="gts-btn-primary-outline ml-2"
                      >
                        <span class="gts-btn-icon-left">close</span>
                        <span class="gts-btn-text">No</span>
                      </button>
                      <button
                        (click)="saveItem()"
                        class="gts-btn-primary-outline ml-2"
                      >
                        <span class="gts-btn-icon-left">check</span>
                        <span class="gts-btn-text">Yes, move here</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="items-error" *ngFor="let item of itemsAdd">
                  Item {{ item.id_inventory }} was added to the batch
                  <i
                    class="material-icons"
                    style="font-size: 16px; color: #4caf50; margin-left: 5px"
                    >check</i
                  >
                </div>
              </div>
              <hr />
              <div
                *ngIf="itemsID.length > 0 || itemsAdd.length > 0"
                class="d-flex justify-content-center"
              >
                <!-- Cuadro izquierdo -->

                <!-- Cuadro derecho -->
                <!-- <div class="custom-box green-box full-width-box">
                  <p class="items-error">
                    <i
                      class="material-icons"
                      style="font-size: 16px; color: #4caf50"
                      >check_box</i
                    >
                    List of items added successfully
                  </p>

      
                </div> -->
              </div>
            </form>
            <div class="d-flex justify-content-start">
              <button
                type="button"
                class="gts-btn-primary-outline mr-2"
                (click)="cleanValues()"
                [disabled]="
                  itemsID.length === 0 &&
                  itemsAdd.length === 0 &&
                  nuevo.value === ''
                "
              >
                <span class="gts-btn-text"> Clean</span>
              </button>
              <button
                type="button"
                class="gts-btn-select-primary"
                (click)="saveItem()"
                [disabled]="!f2.valid || savingItem"
              >
                <!--<i *ngIf="!savingItem" class="fa fa-floppy-o" aria-hidden="true"></i>-->
                <i
                  *ngIf="savingItem"
                  class="fa fa-circle-o-notch fa-spin fa-fw"
                ></i>
                <span class="gts-btn-icon-left">add</span>

                <span class="gts-btn-text">Add Item(s)</span>
              </button>
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab *ngIf="totalItems > 0">
        <ng-template mat-tab-label>
          <mat-icon style="margin-right: 8px">remove_red_eye</mat-icon>
          View Items ({{ totalItems }})
        </ng-template>
        <ng-template matTabContent>
          <div style="padding-top: 20px">
            <mat-toolbar>
              <span class="text-toolbar">{{
                bulk.length === 0
                  ? "Everything"
                  : bulk.length + " items selected"
              }}</span>
              <button
                mat-icon-button
                title="Download"
                data-toggle="tooltip"
                data-placement="right"
                style="color: #000"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="material-icons">file_download</i>
              </button>
              <div class="dropdown-menu">
                <button
                  class="dropdown-item btn btn-outline-primary"
                  (click)="reportWithAttributes()"
                >
                  Report with Attributes (.xlsx)
                </button>
                <button
                  class="dropdown-item btn btn-outline-primary"
                  (click)="reportWithAttributesExtreme()"
                >
                  Report with Attributes Extreme (.xlsx)
                </button>
              </div>
              <button
                mat-icon-button
                title="Attribute Items"
                data-toggle="tooltip"
                data-placement="right"
                style="color: #000"
                (click)="attributeMultipleItems()"
              >
                <i class="material-icons">list_alt</i>
              </button>
              <button
                mat-icon-button
                title="Remove Items"
                data-toggle="tooltip"
                data-placement="right"
                style="color: #000"
                (click)="vaciarContainer(item.id)"
              >
                <i class="material-icons">logout</i>
              </button>
            </mat-toolbar>

            <div *ngIf="item.id !== null">
              <div *ngIf="loadingInventories" style="text-align: center">
                <h2>
                  <b
                    ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    Loading...</b
                  >
                </h2>
              </div>
              <dinamic-table
                *ngIf="!loadingInventories"
                [id]="'inventoryTable'"
                [data]="inventories"
                [columnfilters]="filtros"
                [campoBusqueda]="campoBusqueda"
                [perPage]="itemsPorPagina"
                [page]="paginaActual"
                [total_items_count]="totalItems"
                [total_pages]="totalPaginas"
                [bulk]="bulk"
                (buscar)="getInventories($event, false)"
                (action_button)="actions($event)"
                (changeBulk)="changeBulk($event)"
              ></dinamic-table>
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <!-- *ngIf="
          (item.laptopsDone !== 1 ||
            item.hardDrivesDone !== 1 ||
            item.desktopsDone !== 1 ||
            item.allinoneDone !== 1 ||
            (item.containersDevices > 0 && item.containersDevicesDone != 1) ||
            item.ssdDone !== 1) &&
          !item.dosplit
        " -->
        <ng-template mat-tab-label>
          <mat-icon style="margin-right: 8px">call_split</mat-icon>
          Split Batch
        </ng-template>
        <ng-template matTabContent>
          <div class="tab-pane active" style="padding: 20px">
            <div
              *ngIf="item.containerType == 'HDD/SSD'"
              class="tab-pane active"
              id="link1"
            >
              <div>
                <mat-form-field class="example-full-width has-label">
                  <mat-label> Quantity of HDD?</mat-label>
                  <input
                    type="number"
                    min="0"
                    (keypress)="mtds.onlyNumber($event)"
                    name="hard-drives-split"
                    [(ngModel)]="hardDrivesSplit"
                    matInput
                    required
                    [disabled]="hardDrivesDone === 1"
                  />
                </mat-form-field>
                <mat-form-field class="example-full-width has-label">
                  <mat-label> Quantity of SSD?</mat-label>
                  <input
                    type="number"
                    min="0"
                    (keypress)="mtds.onlyNumber($event)"
                    name="ssd-split"
                    [(ngModel)]="ssdSplit"
                    matInput
                    required
                    [disabled]="ssdDone === 1"
                  />
                </mat-form-field>
                <div *ngIf="item.allInOneSplit > 0" class="col-md-6">
                  <mat-form-field class="example-full-width has-label">
                    <mat-label> Quantity of AIO?</mat-label>
                    <input
                      type="number"
                      min="0"
                      (keypress)="mtds.onlyNumber($event)"
                      name="aio-split"
                      [(ngModel)]="allInOneSplit"
                      matInput
                      required
                      [disabled]="item.allInOne == 0"
                    />
                  </mat-form-field>
                </div>
                <div *ngIf="item.desktops > 0" class="col-md-6">
                  <mat-form-field class="example-full-width has-label">
                    <mat-label>Quantity of Desktops?</mat-label>
                    <input
                      type="number"
                      min="0"
                      (keypress)="mtds.onlyNumber($event)"
                      name="desktops-split"
                      [(ngModel)]="desktopsSplit"
                      matInput
                      required
                      [disabled]="item.desktops == 0"
                    />
                  </mat-form-field>
                </div>
                <div *ngIf="item.laptops > 0" class="col-md-6">
                  <mat-form-field class="example-full-width has-label">
                    <mat-label>Quantity of Laptops?</mat-label>
                    <input
                      type="number"
                      min="0"
                      (keypress)="mtds.onlyNumber($event)"
                      name="laptops-split"
                      [(ngModel)]="laptopsSplit"
                      matInput
                      required
                      [disabled]="item.laptops == 0"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div
              *ngIf="item.containerType == 'Devices'"
              class="tab-pane active"
              id="link1"
            >
              <div>
                <mat-form-field class="example-full-width has-label">
                  <mat-label> Quantity of AIO?</mat-label>
                  <input
                    type="number"
                    min="0"
                    (keypress)="mtds.onlyNumber($event)"
                    name="aio-split"
                    [(ngModel)]="allInOneSplit"
                    matInput
                    required
                    [disabled]="allInOneDone === 1 && item.allInOne == 0"
                  />
                </mat-form-field>
                <mat-form-field class="example-full-width has-label">
                  <mat-label> Quantity of Desktops?</mat-label>
                  <input
                    type="number"
                    min="0"
                    (keypress)="mtds.onlyNumber($event)"
                    name="desktops-split"
                    [(ngModel)]="desktopsSplit"
                    matInput
                    required
                    [disabled]="desktopsDone === 1 && item.desktops == 0"
                  />
                </mat-form-field>
                <mat-form-field class="example-full-width has-label">
                  <mat-label> Quantity of Laptops?</mat-label>
                  <input
                    type="number"
                    min="0"
                    (keypress)="mtds.onlyNumber($event)"
                    name="laptops-split"
                    [(ngModel)]="laptopsSplit"
                    matInput
                    required
                    [disabled]="laptopsDone === 1 && item.laptops == 0"
                  />
                </mat-form-field>

                <div *ngIf="hardDrives > 0" class="col-md-6">
                  <mat-form-field class="example-full-width has-label">
                    <mat-label>Quantity of HDD?</mat-label>
                    <input
                      type="number"
                      min="0"
                      (keypress)="mtds.onlyNumber($event)"
                      name="hard-drives-split"
                      [(ngModel)]="hardDrivesSplit"
                      matInput
                      required
                      [disabled]="hardDrives == 0"
                    />
                  </mat-form-field>
                </div>
                <div *ngIf="ssdSplit > 0" class="col-md-6">
                  <mat-form-field class="example-full-width has-label">
                    <mat-label> Quantity of SSD?</mat-label>
                    <input
                      type="number"
                      min="0"
                      (keypress)="mtds.onlyNumber($event)"
                      name="ssd-split"
                      [(ngModel)]="ssdSplit"
                      matInput
                      required
                      [disabled]="ssdDone === 1"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div
              *ngIf="item.containerType == 'Mobile Devices'"
              class="tab-pane active"
              id="link3"
            >
              <mat-form-field class="example-full-width has-label">
                <mat-label> Quantity Mobile Devices?</mat-label>
                <input
                  type="number"
                  min="0"
                  (keypress)="mtds.onlyNumber($event)"
                  name="mobileDevices-split"
                  [(ngModel)]="mobileDevicesSplit"
                  matInput
                  required
                  [disabled]="
                    mobileDevicesDone === 1 && item.mobileDevices == 0
                  "
                />
              </mat-form-field>
            </div>

            <h3
              style="
                text-align: center;
                font-weight: 600;
                font-size: larger;
                color: #919191;
              "
            >
              New Batch Info
            </h3>
            <div class="">
              <div class="">
                <mat-form-field class="example-full-width has-label">
                  <mat-label for="newContainerType_split"
                    >New Container Type</mat-label
                  >
                  <mat-select
                    name="newContainerType_split"
                    id="newContainerType_split"
                    [(ngModel)]="newContainerType_split"
                    (change)="changeNewContainerType($e)"
                  >
                    <mat-option disabled="yes" value="">
                      Please select an option
                    </mat-option>
                    <mat-option
                      *ngFor="let itemContainer of containersType"
                      [value]="itemContainer.name"
                    >
                      {{ itemContainer.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- <label style="margin-top: 7px" for="newContainerType_split"
                  >New Container Type?</label
                >
                <select
                  style="margin-top: 18px"
                  name="newContainerType_split"
                  id="newContainerType_split"
                  #newContainerType_splitForm="ngModel"
                  [(ngModel)]="newContainerType_split"
                  (change)="changeNewContainerType($e)"
                  class="form-control"
                >
                  <option disabled="yes" value="">
                    Please select an option
                  </option>
                  <option
                    *ngFor="let itemContainer of containersType"
                    [value]="itemContainer.name"
                  >
                    {{ itemContainer.name }}
                  </option>
                </select> -->
              </div>

              <div class="">
                <!-- <label
                  ><i
                    *ngIf="loadingLocationsNewContainer"
                    class="fa fa-circle-o-notch fa-spin fa-fw"
                  ></i>
                  Location</label
                > -->

                <app-filter-object
                  *ngIf="!loadingLocationsNewContainer"
                  [options]="locationsListNewContainer"
                  placeholder="Locations"
                  [value]="newcontainerInternallocation_id"
                  (selectChange)="changeLocationNewContainerSplit($event)"
                  [disabled]="locationsListNewContainer.length == 0"
                >
                </app-filter-object>
              </div>
              <div class="">
                <mat-form-field class="example-full-width has-label">
                  <mat-label> Weight</mat-label>
                  <input
                    type="number"
                    min="0"
                    name="newweightsplit-split"
                    [(ngModel)]="newWeightSplit"
                    matInput
                    required
                  />
                </mat-form-field>
              </div>
            </div>

            <div>
              <div *ngIf="errorHardDrives">
                <div class="alert alert-danger" role="alert">
                  The number of Hard Drives can't be greater
                </div>
              </div>
              <div *ngIf="errorLaptops">
                <div class="alert alert-danger" role="alert">
                  The number of Laptops can't be greater
                </div>
              </div>
              <div *ngIf="errorAllInOne">
                <div class="alert alert-danger" role="alert">
                  The number of All In One can't be greater
                </div>
              </div>
              <div *ngIf="errorDesktops">
                <div class="alert alert-danger" role="alert">
                  The number of Desktops can't be greater
                </div>
              </div>

              <div *ngIf="errorMobileDevices">
                <div class="alert alert-danger" role="alert">
                  The number of Mobile Devices can't be greater
                </div>
              </div>
            </div>

            <div class="d-flex">
              <button
                (click)="item.dosplit = false"
                class="gts-btn-primary-outline"
              >
                <span class="gts-btn-text">Cancel</span>
              </button>

              <button
                class="gts-btn-primary ml-3"
                (click)="saveSplitManifest()"
                [disabled]="
                  (laptopsSplit == 0 &&
                    desktopsSplit == 0 &&
                    allInOneSplit == 0 &&
                    hardDrivesSplit == 0 &&
                    ssdSplit == 0 &&
                    mobileDevicesSplit == 0) ||
                  saveSplit
                "
              >
                <span class="gts-btn-icon-left">save</span>
                <span class="gts-btn-text">Save</span>
              </button>
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style="margin-right: 8px">chat</mat-icon>
          Comments ({{ numChats }})
        </ng-template>
        <div>
          <app-comments
            *ngIf="!loadingChats"
            style="width: 100%"
            [id_phather]="item.id"
            type_chat="BATCH"
            [message]="message"
            [item]="item"
            [disabled]="false"
            (total_chats)="numChats = $event"
          ></app-comments>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style="margin-right: 8px">attach_file</mat-icon>
          Files ({{ numFiles }})
        </ng-template>
        <div>
          <app-multi-files
            [idfather]="item.id"
            [type]="'FILESBATCH'"
            (total)="numFiles = $event"
          ></app-multi-files>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div>
    <div *ngIf="!showMarkCompletedForm" class="testeando">
      <!-- comments -->

      <!-- <div class="row">
        <div
          class="col-md-12"
          style="display: none"
          class="commentbox-{{ item.id }}"
        >
          <app-comments
            style="width: 100%"
            [id_phather]="item.id"
            type_chat="BATCH"
            [message]="message"
            [item]="item"
            [disabled]="false"
            (total_chats)="total_chats_func($event)"
          ></app-comments>
        </div>
      </div> -->

      <!-- comments -->

      <div *ngIf="!item.dosplit" style="display: none" class="">
        <div class="tab-content tab-space">
          <div
            *ngIf="item.containerType == 'HDD/SSD'"
            class="tab-pane active"
            id="link1"
          >
            <mat-form-field class="example-full-width has-label">
              <mat-label for="caddiesForm"
                >Do the drives have caddies?</mat-label
              >
              <mat-select
                disabled
                name="caddiesForm"
                id="caddiesForm"
                [(ngModel)]="item.caddies"
                (change)="changecaddies($e)"
              >
                <mat-option value="">Please select an option</mat-option>
                <mat-option value="YesALL">Yes - All</mat-option>
                <mat-option value="YesSome">Yes - Some</mat-option>
                <mat-option value="No">No</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="d-flex">
              <mat-form-field class="example-full-width has-label mr-2">
                <mat-label> Quantity of HDD?</mat-label>
                <input
                  type="number"
                  min="0"
                  (keypress)="mtds.onlyNumber($event)"
                  name="hdd_qty"
                  [(ngModel)]="item.hardDrives"
                  matInput
                  disabled
                />
              </mat-form-field>
              <button
                [disabled]="item.processingHDD"
                (click)="showMarkDone(item, 'HARDDRIVES')"
                *ngIf="
                  item.hardDrives > 0 &&
                  (item.hardDrivesDone == 0 || item.hardDrivesDone == null)
                "
                class="gts-btn-primary-outline"
              >
                <span *ngIf="!item.processingHDD" class="gts-btn-icon-left"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingHDD" class="gts-btn-icon-left"
                  >sync</span
                >
                <span class="gts-btn-text">{{
                  item.processingHDD ? "" : "Mark as done"
                }}</span>
              </button>
            </div>
            <div class="d-flex">
              <mat-form-field class="example-full-width has-label mr-2">
                <mat-label> Quantity of SSD?</mat-label>
                <input
                  type="number"
                  min="0"
                  (keypress)="mtds.onlyNumber($event)"
                  name="ssd_qty"
                  [(ngModel)]="item.ssd"
                  matInput
                  disabled
                />
              </mat-form-field>
              <button
                [disabled]="item.processingSSD"
                (click)="showMarkDone(item, 'SSD')"
                *ngIf="
                  item.ssd > 0 && (item.ssdDone == 0 || item.ssdDone == null)
                "
                class="gts-btn-primary-outline"
              >
                <span *ngIf="!item.processingSSD" class="gts-btn-icon-left"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingSSD" class="gts-btn-icon-left"
                  >sync</span
                >
                <span class="gts-btn-text">
                  {{ item.processingSSD ? "" : "Mark as done" }}
                </span>
              </button>

              <button
                *ngIf="item.ssdDone == 1 && item.ssd > 0"
                class="gts-btn-primary-outline"
                disabled
              >
                <span class="gts-btn-icon-left"> check_circle_outline </span>
                <span class="gts-btn-text"> Done</span>
              </button>
            </div>

            <!-- <div class="d-flex">
              <h5 style="font-weight: 500">Do the drives have caddies?</h5>
              <p class="ml-3" *ngIf="item.caddies == 'YesALL'">Yes - All</p>
              <p class="ml-3" *ngIf="item.caddies == 'YesSome'">Yes - Some</p>
              <p class="ml-3" *ngIf="item.caddies == 'No'">No</p>
            </div> -->
            <!-- <div class="d-flex">
              <h5 style="font-weight: 500">Quantity of HDD:</h5>
              <p class="ml-3">{{ item.hardDrives ? item.hardDrives : 0 }}</p>
              <button
                [disabled]="item.processingHDD"
                (click)="showMarkDone(item, 'HARDDRIVES')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.hardDrives > 0 &&
                  (item.hardDrivesDone == 0 || item.hardDrivesDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingHDD" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingHDD" class="material-icons"
                  >sync</span
                >
                {{ item.processingHDD ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.hardDrivesDone == 1 && item.hardDrives > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button>
            </div>
            <div class="d-flex">
              <h5 style="font-weight: 500">Quantity of SSD:</h5>
              <p class="ml-3">{{ item.ssd ? item.ssd : 0 }}</p>
              <button
                [disabled]="item.processingSSD"
                (click)="showMarkDone(item, 'SSD')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.ssd > 0 && (item.ssdDone == 0 || item.ssdDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingSSD" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingSSD" class="material-icons"
                  >sync</span
                >
                {{ item.processingSSD ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.ssdDone == 1 && item.ssd > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button>
            </div> -->
            <div *ngIf="item.allInOne > 0" class="d-flex">
              <mat-form-field class="example-full-width has-label">
                <mat-label>Quantity of AIO</mat-label>
                <input
                  type="number"
                  min="0"
                  name="ssd_qty"
                  [(ngModel)]="item.allInOne"
                  matInput
                  disabled
                />
              </mat-form-field>
              <button
                [disabled]="item.processingAIO"
                (click)="showMarkDone(item, 'AIO')"
                *ngIf="
                  item.allInOne > 0 &&
                  (item.allinoneDone == 0 || item.allinoneDone == null)
                "
                class="gts-btn-primary-outline"
              >
                <span *ngIf="!item.processingAIO" class="gts-btn-icon-left"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingAIO" class="gts-btn-icon-left"
                  >sync</span
                >
                <span class="gts-btn-text">
                  {{ item.processingAIO ? "" : "Mark as done" }}</span
                >
              </button>

              <button
                *ngIf="item.allinoneDone == 1 && item.allInOne > 0"
                class="gts-btn-primary-outline"
                disabled
              >
                <span class="gts-btn-icon-left"> check_circle_outline </span>
                <span class="gts-btn-text"> Done</span>
              </button>
            </div>
            <!-- 
            <div *ngIf="item.allInOne > 0" class="d-flex">
              <h5 style="font-weight: 500">Quantity of AIO:</h5>
              <p class="ml-3">{{ item.allInOne ? item.allInOne : 0 }}</p>

              <button
                [disabled]="item.processingAIO"
                (click)="showMarkDone(item, 'AIO')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.allInOne > 0 &&
                  (item.allinoneDone == 0 || item.allinoneDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingAIO" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingAIO" class="material-icons"
                  >sync</span
                >
                {{ item.processingAIO ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.allinoneDone == 1 && item.allInOne > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button>
            </div> -->
            <div *ngIf="item.desktops > 0" class="d-flex">
              <h5 style="font-weight: 500">Quantity of Desktops:</h5>
              <p class="ml-3">{{ item.desktops ? item.desktops : 0 }}</p>

              <button
                [disabled]="item.processingDESKTOP"
                (click)="showMarkDone(item, 'DESKTOP')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.desktops > 0 &&
                  (item.desktopsDone == 0 || item.desktopsDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingDESKTOP" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingDESKTOP" class="material-icons"
                  >sync</span
                >
                {{ item.processingDESKTOP ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.desktopsDone == 1 && item.desktops > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button>
            </div>
            <div *ngIf="item.laptops > 0" class="d-flex">
              <h5 style="font-weight: 500">Quantity of Laptops:</h5>
              <p class="ml-3">{{ item.laptops ? item.laptops : 0 }}</p>

              <button
                [disabled]="item.processingLAPTOP"
                (click)="showMarkDone(item, 'LAPTOP')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.laptops > 0 &&
                  (item.laptopsDone == 0 || item.laptopsDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingLAPTOP" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingLAPTOP" class="material-icons"
                  >sync</span
                >
                {{ item.processingLAPTOP ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.laptopsDone == 1 && item.laptops > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button>
            </div>
          </div>
          <div
            *ngIf="item.containerType == 'Devices'"
            class="tab-pane active"
            id="link1"
          >
            <div class="d-flex">
              <mat-form-field class="example-full-width has-label mr-2">
                <mat-label>Quantity of AIO</mat-label>
                <input
                  type="number"
                  min="0"
                  name="ssd_qty"
                  [(ngModel)]="item.allInOne"
                  matInput
                  disabled
                />
              </mat-form-field>
              <button
                [disabled]="item.processingAIO"
                (click)="showMarkDone(item, 'AIO')"
                *ngIf="
                  item.allInOne > 0 &&
                  (item.allinoneDone == 0 || item.allinoneDone == null)
                "
                class="gts-btn-primary-outline"
              >
                <span *ngIf="!item.processingAIO" class="gts-btn-icon-left"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingAIO" class="gts-btn-icon-left"
                  >sync</span
                >
                <span class="gts-btn-text">
                  {{ item.processingAIO ? "" : "Mark as done" }}</span
                >
              </button>

              <button
                *ngIf="item.allinoneDone == 1 && item.allInOne > 0"
                class="gts-btn-primary-outline"
                disabled
              >
                <span class="gts-btn-icon-left"> check_circle_outline </span>
                <span class="gts-btn-text"> Done</span>
              </button>
            </div>

            <!-- <div class="d-flex">
              <h5 style="font-weight: 500">Quantity of AIO:</h5>
              <p class="ml-3">{{ item.allInOne ? item.allInOne : 0 }}</p>
              <button
                [disabled]="item.processingAIO"
                (click)="showMarkDone(item, 'AIO')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.allInOne > 0 &&
                  (item.allinoneDone == 0 || item.allinoneDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingAIO" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingAIO" class="material-icons"
                  >sync</span
                >
                {{ item.processingAIO ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.allinoneDone == 1 && item.allInOne > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button>
            </div> -->
            <div class="d-flex">
              <mat-form-field class="example-full-width has-label mr-2">
                <mat-label>Quantity of Desktops</mat-label>
                <input
                  type="number"
                  min="0"
                  name="ssd_qty"
                  [(ngModel)]="item.desktops"
                  matInput
                  disabled
                />
              </mat-form-field>
              <button
                [disabled]="item.processingDESKTOP"
                (click)="showMarkDone(item, 'DESKTOP')"
                *ngIf="
                  item.desktops > 0 &&
                  (item.desktopsDone == 0 || item.desktopsDone == null)
                "
                class="gts-btn-primary-outline"
              >
                <span *ngIf="!item.processingDESKTOP" class="gts-btn-icon-left"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingDESKTOP" class="gts-btn-icon-left"
                  >sync</span
                >
                <span class="gts-btn-text">
                  {{ item.processingDESKTOP ? "" : "Mark as done" }}</span
                >
              </button>

              <button
                *ngIf="item.desktopsDone == 1 && item.desktops > 0"
                class="gts-btn-primary-outline"
                disabled
              >
                <span class="gts-btn-icon-left"> check_circle_outline </span>
                <span class="gts-btn-text"> Done</span>
              </button>
              <!-- <h5 style="font-weight: 500">Quantity of Desktops:</h5>
              <p class="ml-3">{{ item.desktops ? item.desktops : 0 }}</p>
              <button
                [disabled]="item.processingDESKTOP"
                (click)="showMarkDone(item, 'DESKTOP')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.desktops > 0 &&
                  (item.desktopsDone == 0 || item.desktopsDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingDESKTOP" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingDESKTOP" class="material-icons"
                  >sync</span
                >
                {{ item.processingDESKTOP ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.desktopsDone == 1 && item.desktops > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button> -->
            </div>
            <div class="d-flex">
              <mat-form-field class="example-full-width has-label mr-2">
                <mat-label>Quantity of Laptops</mat-label>
                <input
                  type="number"
                  min="0"
                  name="ssd_qty"
                  [(ngModel)]="item.laptops"
                  matInput
                  disabled
                />
              </mat-form-field>
              <button
                [disabled]="item.processingLAPTOP"
                (click)="showMarkDone(item, 'LAPTOP')"
                *ngIf="
                  item.laptops > 0 &&
                  (item.laptopsDone == 0 || item.laptopsDone == null)
                "
                class="gts-btn-primary-outline"
              >
                <span *ngIf="!item.processingLAPTOP" class="gts-btn-icon-left"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingLAPTOP" class="gts-btn-icon-left"
                  >sync</span
                >
                <span class="gts-btn-text">
                  {{ item.processingLAPTOP ? "" : "Mark as done" }}</span
                >
              </button>

              <button
                *ngIf="item.laptopsDone == 1 && item.laptops > 0"
                class="gts-btn-primary-outline"
                disabled
              >
                <span class="gts-btn-icon-left"> check_circle_outline </span>
                <span class="gts-btn-text"> Done</span>
              </button>

              <!-- <h5 style="font-weight: 500">Quantity of Laptops:</h5>
              <p class="ml-3">{{ item.laptops ? item.laptops : 0 }}</p>
              <button
                [disabled]="item.processingLAPTOP"
                (click)="showMarkDone(item, 'LAPTOP')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.laptops > 0 &&
                  (item.laptopsDone == 0 || item.laptopsDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span *ngIf="!item.processingLAPTOP" class="material-icons"
                  >check_circle_outline</span
                >
                <span *ngIf="item.processingLAPTOP" class="material-icons"
                  >sync</span
                >
                {{ item.processingLAPTOP ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.laptopsDone == 1 && item.laptops > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button> -->
            </div>

            <div *ngIf="item.hardDrives > 0" class="d-flex">
              <h5 style="font-weight: 500">Quantity of HDD:</h5>
              <p class="ml-3">{{ item.hardDrives ? item.hardDrives : 0 }}</p>
            </div>
          </div>
          <div
            *ngIf="item.containerType == 'Mobile Devices'"
            class="tab-pane active"
            id="link3"
          >
            <div class="d-flex">
              <h5 style="font-weight: 500">Quantity of Mobile Devices:</h5>
              <p class="ml-3">
                {{ item.mobileDevices ? item.mobileDevices : 0 }}
              </p>

              <button
                [disabled]="item.processingMOBILEDEVICES"
                (click)="showMarkDone(item, 'MOBILEDEVICES')"
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="
                  item.mobileDevices > 0 &&
                  (item.mobileDevicesDone == 0 ||
                    item.mobileDevicesDone == null)
                "
                class="btn btn-info btn-sm"
              >
                <span
                  *ngIf="!item.processingMOBILEDEVICES"
                  class="material-icons"
                  >check_circle_outline</span
                >
                <span
                  *ngIf="item.processingMOBILEDEVICES"
                  class="material-icons"
                  >sync</span
                >
                {{ item.processingMOBILEDEVICES ? "" : "Mark as done" }}
              </button>

              <button
                style="margin-left: 15px; margin-top: 0px"
                *ngIf="item.mobileDevicesDone == 1 && item.mobileDevices > 0"
                class="btn btn-success btn-sm"
              >
                <span class="material-icons"> check_circle_outline </span>Done
              </button>
            </div>
          </div>
          <!-- <div style="width: 145px; display: flex">
              <h5 style="font-weight: 500; align-self: center">Weight:::</h5>
            </div> -->
          <div class="d-flex w-100">
            <mat-form-field class="example-full-width">
              <mat-label>Weight (lbs)</mat-label>
              <input
                [disabled]="weightInputActivated == false"
                id="inputWeight{{ item.id }}"
                matInput
                (keydown.enter)="lockWeight(item)"
                [(ngModel)]="item.weight"
                type="text"
              />
            </mat-form-field>
            <span
              *ngIf="!weightInputActivated"
              (click)="unlockWeight(item)"
              class="material-icons pointer"
            >
              lock
            </span>
            <span
              *ngIf="weightInputActivated"
              (click)="lockWeight(item)"
              class="material-icons pointer"
            >
              lock_open
            </span>
          </div>
          <div
            style="justify-content: end"
            *ngIf="item.internalLocation && item.internalLocation.locationName"
          >
            <div
              *ngIf="locationChanged"
              class="alert alert-success w-100"
              style="width: 100%; display: flex"
              role="alert"
            >
              <span>Location has changed to Wipe Room: 0-0-0-0</span>
            </div>
            <div class="locationinput-{{ item.id }} d-flex">
              <mat-form-field class="example-full-width">
                <mat-label> Current Location: </mat-label>
                <input
                  disabled
                  matInput
                  (change)="handleChange($event)"
                  [(ngModel)]="val"
                  type="text"
                />
              </mat-form-field>
              <span
                (click)="unlocklocation(item)"
                class="material-icons pointer"
              >
                lock
              </span>
            </div>
            <div
              style="display: none; width: 650px"
              class="locationselect-{{ item.id }}"
            >
              <div class="form-group">
                <span
                  (click)="locklocation(item.id)"
                  class="material-icons pointer"
                >
                  lock_open
                </span>
                <label *ngIf="loadingLocationsNewContainer"
                  >Location <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
                ></label>

                <app-filter-object
                  *ngIf="!loadingLocationsNewContainer"
                  [options]="locationsListNewContainer"
                  placeholder="Select new Location"
                  [value]="newcontainerInternallocation_id"
                  (selectChange)="changeLocationEditContainer($event, item)"
                  [disabled]="locationsListNewContainer.length == 0"
                >
                </app-filter-object>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <mat-checkbox
                    class="example-margin"
                    (change)="onCheckboxChange($event)"
                    >Show External Locations</mat-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label *ngIf="loadingUsers"
                >Loading Users <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
              ></label>

              <app-filter-object
                *ngIf="!loadingUsers"
                [options]="usersList"
                [disabled]="assignInputActivated"
                placeholder="Assign User"
                [value]="item.assignTo"
                (selectChange)="item.assignTo = $event.id"
              >
              </app-filter-object>
              <span
                *ngIf="assignInputActivated"
                (click)="unlockAssign(item)"
                class="material-icons pointer"
              >
                lock
              </span>
              <span
                *ngIf="!assignInputActivated"
                (click)="lockAssign(item)"
                class="material-icons pointer"
              >
                lock_open
              </span>
            </div>
          </div>

          <!-- <div
            *ngIf="showInventories"
            style="border: 1px solid black; padding: 20px"
          >
            <mat-toolbar>
              <span class="text-toolbar">{{
                bulk.length === 0
                  ? "Everything"
                  : bulk.length + " items selected"
              }}</span>
              <button
                mat-icon-button
                title="Download"
                data-toggle="tooltip"
                data-placement="right"
                style="color: #000"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="material-icons">file_download</i>
              </button>
              <div class="dropdown-menu">
                <button
                  class="dropdown-item btn btn-outline-primary"
                  (click)="reportWithAttributes()"
                >
                  Report with Attributes (.xlsx)
                </button>
                <button
                  class="dropdown-item btn btn-outline-primary"
                  (click)="reportWithAttributesExtreme()"
                >
                  Report with Attributes Extreme (.xlsx)
                </button>
              </div>
              <button
                mat-icon-button
                title="Attribute Items"
                data-toggle="tooltip"
                data-placement="right"
                style="color: #000"
                (click)="attributeMultipleItems()"
              >
                <i class="material-icons">list_alt</i>
              </button>
              <button
                mat-icon-button
                title="Remove Items"
                data-toggle="tooltip"
                data-placement="right"
                style="color: #000"
                (click)="vaciarContainer(item.id)"
              >
                <i class="material-icons">logout</i>
              </button>
            </mat-toolbar>

            <div *ngIf="item.id !== null">
              <div *ngIf="loadingInventories" style="text-align: center">
                <h2>
                  <b
                    ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    Loading...</b
                  >
                </h2>
              </div>
              <dinamic-table
                *ngIf="!loadingInventories"
                [id]="'inventoryTable'"
                [data]="inventories"
                [columnfilters]="filtros"
                [campoBusqueda]="campoBusqueda"
                [perPage]="itemsPorPagina"
                [page]="paginaActual"
                [total_items_count]="totalItems"
                [total_pages]="totalPaginas"
                [bulk]="bulk"
                (buscar)="getInventories($event, false)"
                (action_button)="actions($event)"
                (changeBulk)="changeBulk($event)"
              ></dinamic-table>
            </div>
          </div> -->
        </div>
      </div>
      <!-- do split -->

      <!-- do split -->
    </div>
    <div *ngIf="showMarkCompletedForm">
      <form #f="ngForm">
        <div *ngIf="item.containerType !== 'Devices'">
          <mat-form-field class="example-full-width">
            <mat-label>How many passed erasure?</mat-label>
            <input
              matInput
              type="number"
              name="How many passed erasure?"
              [(ngModel)]="passed"
            />
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>How many failed erasure?</mat-label>
            <input matInput type="number" name="failed" [(ngModel)]="failed" />
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>How many were DOA?</mat-label>
            <input matInput type="number" name="DOA" [(ngModel)]="doa" />
          </mat-form-field>

          <div *ngIf="!match && (failed || doa || passed)" class="form-group">
            <label>Explanation</label>
            <div class="form-group">
              <textarea
                name="explanation"
                [(ngModel)]="explanation"
                class="form-control"
                rows="2"
              ></textarea>
            </div>
          </div>
        </div>
        <div *ngIf="item.containerType == 'Devices'">
          <mat-form-field class="example-full-width">
            <mat-label>How many devices passed erasure?</mat-label>
            <input
              matInput
              type="number"
              name="How many passed erasure?"
              [(ngModel)]="passed"
            />
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>How many devices failed erasure?</mat-label>
            <input matInput type="number" name="failed" [(ngModel)]="failed" />
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>How many devices were DOA?</mat-label>
            <input matInput type="number" name="DOA" [(ngModel)]="doa" />
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>How many devices didn't have drives?</mat-label>
            <input
              matInput
              type="number"
              name="nodrives"
              [(ngModel)]="noDrives"
            />
          </mat-form-field>
          <div
            *ngIf="!match && (failed || doa || noDrives || passed)"
            class="form-group"
          >
            <label>Explanation</label>
            <div class="form-group">
              <textarea
                name="explanation"
                [(ngModel)]="explanation"
                class="form-control"
                rows="2"
              ></textarea>
            </div>
          </div>
        </div>
        <div *ngIf="addFilesToBatch">
          <app-multi-files
            [idfather]="item.id"
            [type]="'FILESBATCH'"
            (total)="numFiles = $event; viewFiles();"
          ></app-multi-files>
        </div>
        <div class="d-flex">
          <button
            type="button"
            class="gts-btn-primary-outline mr-2"
            (click)="cancel()"
          >
            <span class="gts-btn-text"> Cancel </span>
          </button>
          <div *ngIf="!partDone">
            <button
              *ngIf="item.containerType == 'Devices' || !addFilesToBatch; else HDD"
              type="button"
              [disabled]="
                (!match && !explanation) ||
                (!failed && !doa && !noDrives && !passed)
              "
              (click)="preChangestatusmanifest(item, 'Completed')"
              class="gts-btn-primary"
            >
              <span class="gts-btn-text"> Submit </span>
            </button>
            <ng-template #HDD>
              <button
                *ngIf="!addFilesToBatch"
                type="button"
                [disabled]="
                  (!match && !explanation) || (!failed && !doa && !passed)
                "
                (click)="preChangestatusmanifest(item, 'Completed')"
                class="gts-btn-primary"
              >
                <span class="gts-btn-text"> Submit </span>
              </button>
            </ng-template>
          </div>
          <div *ngIf="partDone">
            <button
              *ngIf="item.containerType == 'Devices' || !addFilesToBatch; else HDD"
              type="button"
              [disabled]="
                (!match && !explanation) ||
                (!failed && !doa && !noDrives && !passed)
              "
              (click)="preSetManifestDone(item, type)"
              class="gts-btn-primary"
            >
              <span class="gts-btn-text"> Submit </span>
            </button>
            <ng-template #HDD>
              <button
                *ngIf="!addFilesToBatch"
                type="button"
                [disabled]="
                  (!match && !explanation) || (!failed && !doa && !passed)
                "
                (click)="preSetManifestDone(item, type)"
                class="gts-btn-primary"
              >
                <span class="gts-btn-text"> Submit </span>
              </button>
            </ng-template>
          </div>
          <br>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- <div
  class="modal fade modalMark"
  id="markCompleted"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  aria-labelledby="exampleModalScrollableTitle"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form #f="ngForm">
          <div>
            <mat-form-field class="example-full-width">
              <mat-label>How many passed erasure?</mat-label>
              <input
                matInput
                type="number"
                name="How many passed erasure?"
                [(ngModel)]="passed"
              />
            </mat-form-field>
            <mat-form-field class="example-full-width">
              <mat-label>How many failed erasure?</mat-label>
              <input
                matInput
                type="number"
                name="failed"
                [(ngModel)]="failed"
              />
            </mat-form-field>
            <mat-form-field class="example-full-width">
              <mat-label>How many were DOA?</mat-label>
              <input matInput type="number" name="DOA" [(ngModel)]="doa" />
            </mat-form-field>
            <div class="form-group">
              <label>Explanation</label>
              <div class="form-group">
                <textarea
                  name="explanation"
                  [(ngModel)]="explanation"
                  class="form-control"
                  rows="2"
                ></textarea>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer" style="text-align: center">
        <button
          type="button"
          class="btn btn-danger mr-2"
          (click)="closeModal()"
        >
          Close
        </button>
        <button type="button" [disabled]="disabledForm" class="btn btn-success">
          Submit
        </button>
      </div>
    </div>
  </div>
</div> -->
